import { createSelector } from '@reduxjs/toolkit';

import { selectExternalTour } from './selectExternalTour';
import { selectNewbuildingTour } from './selectNewbuildingTour';

export const selectTourLink = createSelector(
  selectNewbuildingTour,
  selectExternalTour,
  (tourKey, externalTourKey) => tourKey || externalTourKey,
);
